import React from 'react';

export const pageMeta = {
  "name": "JSON Data Types",
  "link": "/javascript/json/data-types"
};

export default function JavascriptJsonDataTypes() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JSON Data Types</h2>
      <p>Route: /javascript/json/data-types</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
